<template>
  <div>
    <div class="select-container" tabindex="0" @blur="expanded = false">
      <div class="selected-container" :aria-expanded="expanded" @click="toggle">
        <div class="label">
          <p class="small">{{ label }}</p>
        </div>
        <div class="selected-input">
          <div>
            {{ selected.label }}
          </div>
          <div class="icon">
            <pn-icon
              :symbol="expanded ? 'angle-small-up' : 'angle-small-down'"
              :color="expanded ? 'blue700' : 'gray400'"
              size="medium"
              solid
            >
            </pn-icon>
          </div>
        </div>
      </div>
      <div v-show="expanded" class="select-options">
        <div
          v-for="(item, index) in values"
          :key="index"
          class="option"
          @click="handleInput(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    expanded: false,
    selectedValue: {
      label: '',
      value: -1
    }
  }),
  props: {
    label: {
      required: false,
      type: String
    },
    values: {
      required: true,
      type: Array
    },
    value: {
      required: false,
      type: String,
      default: '-1'
    }
  },
  computed: {
    selected() {
      return (
        this.values.find(item => item.value == this.selectedValue.value) ||
        this.selectedValue
      )
    }
  },
  mounted() {
    this.selectedValue.value = this.value
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded
    },
    handleInput(item) {
      this.selectedValue = {
        label: item.label,
        value: item.value
      }
      this.expanded = false
      this.$emit('input', this.selectedValue.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-container {
  position: relative;
  vertical-align: top;
  box-sizing: border-box;
  border: 1px solid $gray200;

  &:hover {
    border: 1px solid #cdeefb;
  }

  .selected-container {
    padding: 0.75em;
    .label {
      color: $gray700;
    }
    .selected-input {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .icon {
        text-align: end;
      }
    }
  }
}

.select-options {
  position: absolute;
  background: #fff;
  overflow: hidden;
  width: 100%;
  border: 1px solid $gray200;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .option {
    padding: 0.75em;
    &:hover {
      background: $blue50;
    }
  }
}
</style>
